<script>
	import StandaloneButton from "./StandaloneButton.svelte";
    import { createEventDispatcher, onDestroy } from 'svelte';
    import { scale } from 'svelte/transition';

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}></div>

<div class="modal box lev0" role="dialog" aria-modal="true" bind:this={modal} transition:scale="{{duration: 250}}">
	<slot></slot>
	<StandaloneButton id="ok" autofocus={true} on:click={close}>GOT IT</StandaloneButton>
</div>

<style>
	.modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
        background: rgba(0, 0, 0, 0.25);
        z-index: 4;
	}

	.modal {
		position: absolute;
		left: 50%;
		top: 50%;
		width: calc(100vw - 2rem);
		max-width: 55em;
		max-height: calc(100vh - 4rem);
		overflow: auto;
		transform: translate(-50%,-50%);
        border: 0.15rem black solid;
		background: white;
        z-index: 5;
		box-shadow: inset 0 0 0 0.5rem #0d8;
		padding: 1.5rem;
		font-size: 0.8rem;
		line-height: 1.5em;
		margin: 0;
	}

	:global(.modal ul) {
		padding-left: 1em;
		margin-top: 0em;
		margin-bottom: 0.75em;
	}

	:global(.modal h4) {
		text-transform: uppercase;
		margin-top: 0.25em;
		margin-bottom: 0.75em;
		letter-spacing: 0.05em;
	}

	:global(.modal p) {
		margin-top: 0;
		margin-bottom: 0.75em;
	}

	:global(.modal a) {
		text-decoration: underline;
		color: #000;
	}

</style>